/**
 * @file のしの掛け方削除
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname DeleteNoshiType
 * @classdesc のしの掛け方削除
 */
export default class DeleteWrappingOfNoshiType {
	/**
	 * @constructor
	 * @param {jQuery} $e - .wrapping_of_noshi_type
	 */
	constructor($e) {
		console.log('DeleteWrappingOfNoshiType.constructor');
		$e.find('option').each((idx, e) => {
			const $e = $(e);
			if($e.val() === '1') {
				$e.remove();
			}
		});
	};
}
